import { UserRatingsResponse } from 'logic/api-models/api-models';

export const getRatingsWithComment = (userRatings: UserRatingsResponse['ratings']) =>
  userRatings.filter(({ comment }) => comment && comment.trim().length > 0);
